import { lazy, Suspense, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Dialog from '@rewardopl/react-ui/dialog';

import LoadingText from './loading_text';

const ServiceContract = lazy(() => import('./service_contract'));

export default function ServiceContractDialog() {
  const location = useLocation();
  const navigate = useNavigate();

  const close = useCallback(() => {
    navigate(
      {
        ...location,
        hash: '',
      },
      { state: location.state },
    );
  }, [location, navigate]);

  return (
    <Dialog
      isOpen={location.hash === '#service-contract'}
      title="Service contract"
      onDismiss={close}
    >
      <Suspense fallback={<LoadingText />}>
        <ServiceContract />
      </Suspense>
    </Dialog>
  );
}
